import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';

import { SharedModule } from '../shared/shared.module';

import { LeadCardComponent } from './lead-card/lead-card.component';
import { LeadCampaignListComponent } from './lead-campaign-list/lead-campaign-list.component';
import { LeadOfferCardComponent } from './modal-participate/lead-offer-card/lead-offer-card.component';
import { LeadHomeComponent } from './lead-home/lead-home.component';
import { ModalParticipateComponent } from './modal-participate/modal-participate.component';
import { ModelSummaryComponent } from './model-summary/model-summary.component';
import { ParticipantsCardComponent } from './participants-card/participants-card.component';
import { LeadConfirmComponent } from './lead-confirm/lead-confirm.component';
import { LeadCampaignComponent  } from './lead-campaign.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { ApplicationSummaryComponent } from './application-summary/application-summary.component';
import { MatProgressSpinnerModule } from '@angular/material';
import { FaqComponent } from './faq/faq.component';
import { FaqHomeComponent } from './faq/faq-home/faq-home.component';
import { FaqCardComponent } from './faq/faq-card/faq-card.component';
import { FaqListComponent } from './faq/faq-list/faq-list.component';
import { FaqItemComponent } from './faq/faq-list/faq-item/faq-item.component';


@NgModule({
  declarations: [
    LeadCampaignComponent,
    LeadCardComponent,
    LeadCampaignListComponent,
    LeadHomeComponent,
    LeadOfferCardComponent,
    ModalParticipateComponent,
    ModelSummaryComponent,
    ParticipantsCardComponent,
    LeadConfirmComponent,
    AutocompleteComponent,
    ApplicationSummaryComponent,
    FaqComponent,
    FaqHomeComponent,
    FaqCardComponent,
    FaqListComponent,
    FaqItemComponent
  ],
  imports: [
    SharedModule,
    RouterModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  exports: [
    LeadCampaignComponent,
    LeadCardComponent,
    LeadCampaignListComponent,
    LeadHomeComponent,
    LeadOfferCardComponent,
    ModalParticipateComponent,
    ModelSummaryComponent,
    ParticipantsCardComponent,
    LeadConfirmComponent,
    AutocompleteComponent,
    ApplicationSummaryComponent,
    FaqComponent,
    FaqHomeComponent,
    FaqListComponent,
    FaqItemComponent
  ]
})
export class LeadCampaignModule { }
